<template>
  <span>
    <m-button theme="icon" :icon="faInfoCircle" @click="showInfo = true"> </m-button>
    <m-modal v-if="showInfo" @close="showInfo = false">
      <slot />
      <template #actions>
        <m-button @click="showInfo = false">Close</m-button>
      </template>
    </m-modal>
  </span>
</template>
<script setup lang="ts">
  import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
  import { ref } from 'vue';
  import { MIconProps } from '@core/components/MIcon';
  import MModal from '../MModal/MModal.vue';

  const showInfo = ref(false);
</script>
